/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { isEmpty } from "lodash";
import {
    ConnectionTypes,
    DeltaLakeIngestionProperties,
    IngestionLocator,
    KafkaIngestionProperties,
    KinesisIngestionProperties,
    S3IngestionProperties,
} from "../../rest/dto/datasources.interfaces";
import { DatasetState } from "../../store/dataset-ingestion/dataset-ingestion.interfaces";
import { getJSONFromString } from "../utils";

export const getLocatorValue = (
    connectionType: ConnectionTypes,
    dataset: DatasetState
): string | undefined => {
    const ingestionLocator = dataset.ingestionLocator as IngestionLocator;

    switch (connectionType) {
        case ConnectionTypes.BIG_QUERY:
            return ingestionLocator.locator;
        case ConnectionTypes.DELTA_LAKE:
            return ingestionLocator[DeltaLakeIngestionProperties.TABLE_URI];
        case ConnectionTypes.KAFKA:
        case ConnectionTypes.CONFLUENT_CLOUD:
            return ingestionLocator[KafkaIngestionProperties.TOPIC_NAME];
        case ConnectionTypes.KINESIS:
            return ingestionLocator[KinesisIngestionProperties.STREAM_NAME];
        case ConnectionTypes.S3: {
            const isMultiPath =
                !!(S3IngestionProperties.INPUT_PATHS in ingestionLocator) &&
                !!ingestionLocator[S3IngestionProperties.INPUT_PATHS] &&
                !isEmpty(ingestionLocator[S3IngestionProperties.INPUT_PATHS]);

            const multiPathLocator: string =
                (isMultiPath &&
                    ingestionLocator[S3IngestionProperties.INPUT_PATHS] &&
                    getJSONFromString<string[]>(
                        ingestionLocator[
                            S3IngestionProperties.INPUT_PATHS
                        ] as string
                    )?.join(", ")) ||
                "";

            return isMultiPath
                ? multiPathLocator
                : ingestionLocator[S3IngestionProperties.INPUT_PATH];
        }
        case ConnectionTypes.SNOWFLAKE:
            return ingestionLocator.locator;
        case ConnectionTypes.UPLOAD:
            return dataset.uploadFile?.name || "-";
        default:
            return undefined;
    }
};
